import { render, staticRenderFns } from "./ChatRoomMenu.vue?vue&type=template&id=08be0f79&scoped=true&lang=html&"
import script from "./ChatRoomMenu.vue?vue&type=script&lang=js&"
export * from "./ChatRoomMenu.vue?vue&type=script&lang=js&"
import style0 from "./ChatRoomMenu.vue?vue&type=style&index=0&id=08be0f79&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be0f79",
  null
  
)

export default component.exports